import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { handleGoogleLogin, getCurrentUser } from './Auth'; 
import { useNavigate } from 'react-router-dom';

const HeroSection = ({ setUser }) => {
  const navigate = useNavigate();

  const handleGetStarted = async () => {
    await handleGoogleLogin();
    setUser(getCurrentUser()); 
    navigate('/home'); 
  };

  return (
    <Box sx={{ bgcolor: '#f5f5f5', py: 5 }}>
      <Container>
        <Typography variant="h2" gutterBottom>
          Learn from the Best in Tech
        </Typography>
        <Typography variant="h6" color="textSecondary" paragraph>
          Discover high-quality courses from industry experts in React, Firebase, and more.
        </Typography>
        <Button variant="contained" color="primary" size="large" onClick={handleGetStarted}>
          Get Started
        </Button>
      </Container>
    </Box>
  );
};

export default HeroSection;
